(function () {
  function stripEditorAttributes(element) {
    Array.from(element.attributes).forEach(function (attribute) {
      if (attribute.name === 'id' || attribute.name.indexOf('data-shopify') === 0) {
        element.removeAttribute(attribute.name);
      }
    });
    element.querySelectorAll('[id], [data-shopify]').forEach(stripEditorAttributes);
  }

  function setupSocialProofLoop(root) {
    var scope = root || document;
    if (!document.getElementById('fh-social-proof-loop-style')) {
      var style = document.createElement('style');
      style.id = 'fh-social-proof-loop-style';
      style.textContent = '.fh-social-proof__track{animation-play-state:running!important}';
      document.head.appendChild(style);
    }

    var carousels = [];
    if (scope.matches && scope.matches('.fh-social-proof')) carousels.push(scope);
    scope.querySelectorAll && scope.querySelectorAll('.fh-social-proof').forEach(function (carousel) {
      carousels.push(carousel);
    });

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-fh-social-proof-track], .fh-social-proof__track');
      if (!track) return;

      track.querySelectorAll('[data-fh-social-proof-clone], .fh-social-proof-card[aria-hidden="true"]').forEach(function (clone) {
        clone.remove();
      });

      var cards = Array.from(track.querySelectorAll('[data-fh-social-proof-card]'));
      if (!cards.length) cards = Array.from(track.querySelectorAll('.fh-social-proof-card'));
      if (!cards.length) return;

      var computed = window.getComputedStyle(track);
      var gap = Number.parseFloat(computed.columnGap || computed.gap) || 0;
      var firstRect = cards[0].getBoundingClientRect();
      var lastRect = cards[cards.length - 1].getBoundingClientRect();
      var distance = Math.max(1, lastRect.right - firstRect.left + gap);
      track.style.setProperty('--fh-social-proof-loop-distance', Math.round(distance) + 'px');

      var filledWidth = distance;
      var cloneRounds = 0;
      var minimumWidth = distance + window.innerWidth * 2;
      while (filledWidth < minimumWidth && cloneRounds < 10) {
        cards.forEach(function (card) {
          var clone = card.cloneNode(true);
          clone.setAttribute('data-fh-social-proof-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          stripEditorAttributes(clone);
          track.appendChild(clone);
        });
        filledWidth += distance;
        cloneRounds += 1;
      }

      var configuredSpeed = Number.parseFloat(track.style.getPropertyValue('--fh-social-proof-speed')) || 64;
      track.style.setProperty('animation-duration', Math.max(58, configuredSpeed) + 's', 'important');
      track.style.animationPlayState = 'running';
    });
  }

  function run() {
    setupSocialProofLoop(document);
    window.setTimeout(function () { setupSocialProofLoop(document); }, 250);
    window.setTimeout(function () { setupSocialProofLoop(document); }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  window.addEventListener('resize', function () {
    window.requestAnimationFrame(function () { setupSocialProofLoop(document); });
  });
  document.addEventListener('shopify:section:load', function (event) {
    setupSocialProofLoop(event.target);
  });
})();
